export const workweekSteps = () => {
  return [
    {
      target: '[data-tour="workweek-module"]',
      title: '📅 Welcome to Workweek Module',
      content:
        'Here you can define working days, create work week rules, and assign them to employees.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="workweek-create-tab"]',
      title: '🏗 Create Work Week',
      content:
        'Create custom work week rules like full-day, half-day, or holidays for different days.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="workweek-assign-tab"]',
      title: '👥 Assign Work Week',
      content:
        'Assign created work week rules to employees or departments.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="workweek-create-rule"]',
      title: '👥 Create Rule for Work Week',
      content: 'Assign created work week rules to employees or departments.',
      disableBeacon: true,
    }
  ];
}